import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-footer-type07',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink],
  templateUrl: './footer-type07.component.html',
  styleUrl: './footer-type07.component.scss'
})
export class FooterType07Component implements OnInit {

  public view: any = {
    emailLink: '',
    quickLinks: [] as { title: string; link: string; externalLink?: boolean; target?: string }[],
  }

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef) {

    this._tfmService.getSite().then(res => {
      this.view.site = res;

      const email = this.view?.site?.emailAddress;
      const subject = this.view?.site?.name + ' | TFM New Notification from Contact';
      this.view.emailLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this.buildQuickLinks();
    });

    this._tfmService.getPages().then((res: any) => {
      this.view.pages = res.content.filter(x => !(x.section === 'about' || x.section === 'contact' || x.section === 'travel' || x.section === 'corporate-travel' || x.section === 'leisure-travel' || x.section === 'xl-howzit-promo' || x.section === 'team' || x.section === 'non-profit' || x.section === 'rail'));
    });

    this._tfmService.getSiteLayoutOptions().subscribe(res => {
      this.view.layoutOptions = res;
    });
  }

  private buildQuickLinks(): void {
    this.view.quickLinks = [];
    const site = this.view.site;
    if (!site?.profile?.heading?.menu) return;
    const menu = site.profile.heading.menu;
    const items = (m: number) => {
      switch (m) {
        case 1:
          return [
            { title: 'Home', link: '/' },
            { title: 'Destinations', link: '/destinations' },
            { title: 'Our Team', link: '/team' },
            { title: 'About', link: '/about-us' },
            { title: 'Contact', link: '/contact-us' },
          ];
        case 2:
          return [
            { title: 'Home', link: '/' },
            { title: 'About', link: '/about-us' },
            { title: 'OUR MEMBERS', link: '/branches' },
            { title: 'Corporate', link: '/corporate-travel' },
            { title: 'HOLIDAYS', link: '/leisure-travel' },
            { title: 'SPECIALS', link: '/promotional' },
            { title: 'XLGO TRAVEL APP', link: 'https://www.xltravel.co.za/xlgo/', externalLink: true, target: '_blank' },
            { title: 'Contact', link: '/contact-us' },
          ];
        case 3:
          return [
            { title: 'Home', link: '/' },
            { title: 'About', link: '/about-us' },
            { title: 'World Cruises', link: '/world-cruises' },
            { title: 'Gallery', link: '/gallery' },
            { title: 'Contact', link: '/contact-us' },
          ];
        case 4:
          return [
            { title: 'Home', link: '/' },
            { title: 'About', link: '/about-us' },
            { title: 'Our Team', link: '/team' },
            { title: 'Optima Rail', link: '/packages/rail' },
            { title: 'Business Travel', link: '/corporate-travel' },
            { title: 'Holiday Travel', link: '/packages' },
            { title: 'Specials', link: '/promotional' },
            { title: 'Our Blog', link: '/blog/travel-blog' },
            { title: 'CIC Bookings', link: '/cic-booking-form' },
            { title: 'Contact', link: '/contact-us' },
          ];
        case 5:
          return [
            { title: 'Home', link: '/' },
            { title: 'About', link: '/about-us' },
            { title: 'OUR MEMBERS', link: '/team' },
            { title: 'Corporate', link: '/corporate-travel' },
            { title: 'Leisure Travel', link: '/leisure-travel' },
            { title: 'Specials', link: '/promotional' },
            { title: 'XL GO TRAVEL APP', link: 'https://www.xltravel.co.za/xlgo/', externalLink: true, target: '_blank' },
            { title: 'Contact', link: '/contact-us' },
          ];
        case 6:
          return [
            { title: 'Home', link: '/' },
            { title: 'About', link: '/about-us' },
            { title: 'Our Team', link: '/team' },
            { title: 'Humanitarian', link: '/non-profit' },
            { title: 'Corporate', link: '/corporate-travel' },
            { title: 'Leisure Travel', link: '/leisure-travel' },
            { title: 'Specials', link: '/promotional' },
            { title: 'Contact', link: '/contact-us' },
          ];
        case 7:
          return [
            { title: 'Home', link: '/' },
            { title: 'About', link: '/about-us' },
            { title: 'Our Team', link: '/team' },
            { title: 'Corporate', link: '/corporate-travel' },
            { title: 'Packages', link: '/packages' },
            { title: 'Specials', link: '/promotional' },
            { title: 'Contact', link: '/contact-us' },
          ];
        default:
          return [];
      }
    };
    this.view.quickLinks = items(menu).filter(x => x.title !== 'Home');
    this._cd.detectChanges();
  }

  get currentYear(): number {
    return new Date().getFullYear();
  };

  ngOnInit(): void {
  }
}
